export default {
  guest: {
    earn_pts: '{{points}} Pkt. bei dieser Bestellung verdienen',
    tagline: 'Sammle Punkte mit jeder Bestellung',
    pick_reward: 'Wähle was du willst, wenn du so weit bist',
    free_at: 'gratis ab {{points}} Pkt.',
    save_at: '{{amount}} sparen ab {{points}} Pkt.',
    nearest: 'am nächsten',
    cta: 'Jetzt starten — kostenlos',
    already_member: 'Schon Mitglied?',
    sign_in: 'Anmelden',
  },
  member: {
    earning_free: 'Du verdienst kostenloses Essen',
    every_euro_one: 'Jeder ausgegebene {{amount}} = 1 Pkt. Einlösen für Gratisartikel & Rabatte.',
    every_euro_other: 'Jeder ausgegebene {{amount}} = {{count}} Pkt. Einlösen für Gratisartikel & Rabatte.',
    until_redeem: 'Noch {{remaining}} Pkt. bis du einlösen kannst',
    unlock_first: 'Diese Bestellung schaltet deine erste Belohnung frei!',
    so_close: 'Fast geschafft!',
    just_more: 'Nur noch {{remaining}} Pkt. und du kannst sparen.',
    pts_to_unlock: '{{remaining}} Pkt. bis Belohnungen freigeschaltet',
    this_order_unlocks: 'Diese Bestellung bringt dich auf {{points}} Pkt. — nächstes Mal einlösen!',
    save_next: 'Spare bis zu {{amount}} beim nächsten Mal',
    pts_from_order: '+{{earned}} Pkt. aus dieser Bestellung — nur noch {{remaining}} übrig!',
    rewards_value: '= {{amount}} an Belohnungen',
    save_this_order: 'Spare bis zu {{amount}} bei dieser Bestellung',
    use_pts: 'Nutze deine {{points}} Pkt. an der Kasse',
    earned_this_order: '+{{points}} Pkt. mit dieser Bestellung verdient',
    current: 'Aktuell',
    from_this_order: '+{{points}} aus dieser Bestellung',
    expiration_zero: '{{points}} Pkt. verfallen heute',
    expiration_one: '{{points}} Pkt. verfallen in 1 Tage',
    expiration_other: '{{points}} Pkt. verfallen in {{count}} Tagen',
  },
};
